import { Paper, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/index'

interface BreadcrumbsProps {
  numberOfLevels: number
}
const BreadcrumbsSkelton: React.FC<BreadcrumbsProps> = ({ numberOfLevels }) => {
  const classes = useStyles()

  return (
    <Paper className={classes.topBar}>
      {Array(numberOfLevels - 1)
        .fill('')
        .map((_, index) => {
          return (
            <div className={classes.up} key={index.toString()}>
              <Typography variant="body1">
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
              <Typography variant="body1">/</Typography>
            </div>
          )
        })}
      <Typography variant="body1">
        <Skeleton animation="wave" className={classes.skeleton} />
      </Typography>
    </Paper>
  )
}
export default BreadcrumbsSkelton
